import { Layout } from 'react-admin';
import { AppBarM } from '../AppBarM/AppBarM';
export const LayoutM = props => <Layout {...props} appBar={AppBarM} />;